import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import {fetchMediaList, uploadMedia} from '../../services/api';
import Loader from '../Loader';
import Alert from '../Alert';
import Pager from '../Pager';
import messages from '../../../res/translations/messages';

const PAGE_SIZE = 12;

class MediaGalleryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [], count: 0, page: 1, filterText: '',
            loading: false, uploading: false, error: null, selecting: false,
        };
        this.goToPage = this.goToPage.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({page: 1, filterText: '', selecting: false}, () => this.loadPage());
        }
    }

    async loadPage() {
        this.setState({loading: true, error: null});
        try {
            const response = await fetchMediaList((this.state.page - 1) * PAGE_SIZE, PAGE_SIZE, this.state.filterText);
            this.setState({items: response.data.items, count: response.data.count, loading: false});
        } catch (error) {
            this.setState({loading: false, error});
        }
    }

    goToPage(page) {
        this.setState({page}, () => this.loadPage());
    }

    handleFilterChange(e) {
        const filterText = e.target.value;
        this.setState({filterText, page: 1}, () => this.loadPage());
    }

    handleSelect(item) {
        if (this.state.selecting) {
            return;
        }
        this.setState({selecting: true});
        this.props.onSelect({assetId: item.id, url: item.url});
        this.props.toggle();
    }

    selectItem(item) {
        return () => this.handleSelect(item);
    }

    async handleUpload(e) {
        const file = e.target.files[0];
        e.target.value = '';
        if (!file) {
            return;
        }
        this.setState({uploading: true, error: null});
        try {
            const response = await uploadMedia(file);
            this.setState({uploading: false});
            this.handleSelect(response.data);
        } catch (error) {
            this.setState({uploading: false, error});
        }
    }

    render() {
        const {isOpen, toggle} = this.props;
        const {items, count, page, filterText, loading, uploading, error} = this.state;

        return (
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    <FormattedMessage {...messages.media.modals.picker.title} />
                </ModalHeader>
                <ModalBody>
                    <div className="row mb-3 align-items-center">
                        <div className="col">
                            <FormattedMessage {...messages.media.list.filterPlaceholder}>
                                {(placeholder) => (
                                    <input type="text" className="form-control" placeholder={placeholder}
                                        value={filterText} onChange={this.handleFilterChange} />
                                )}
                            </FormattedMessage>
                        </div>
                        <div className="col-auto">
                            <label className={classNames('btn btn-primary mb-0', {disabled: uploading})}>
                                <FormattedMessage {...(uploading ? messages.media.button.uploading : messages.media.modals.picker.uploadTab)} />
                                <input type="file" accept="image/*" hidden disabled={uploading} onChange={this.handleUpload} />
                            </label>
                        </div>
                    </div>
                    <Alert error={error} />
                    {loading ? <Loader /> : (
                        <div className="row">
                            {items.length === 0 && <p className="col text-center text-muted"><FormattedMessage {...messages.media.list.empty} /></p>}
                            {items.map((item) => (
                                <div className="col-4 col-md-3 mb-3" key={item.id}>
                                    <a onClick={this.selectItem(item)} className="card h-100 text-decoration-none">
                                        <img src={item.thumbUrl || item.url} className="card-img-top" alt={item.filename}
                                            style={{objectFit: 'cover', height: 100, width: '100%'}} />
                                        <div className="card-body p-2">
                                            <p className="card-text text-truncate mb-0" title={item.filename}>{item.filename}</p>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    )}
                    <Pager className="justify-content-end" pages={Math.ceil(count / PAGE_SIZE)} current={page} onClick={this.goToPage} />
                </ModalBody>
            </Modal>
        );
    }
}

MediaGalleryModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

export default MediaGalleryModal;
